import React from "react";
import "./ShopPromises.css";

const promises = [
  {
    img: "https://cdn.grofers.com/cdn-cgi/image/f=auto,fit=scale-down,q=70,metadata=none,w=90/assets/web/blinkit-promises/10_minute_delivery.png",
    title: "Superfast Delivery",
    desc: "Get your order delivered to your doorstep at the earliest from nearby stores.",
  },
  {
    img: "https://cdn.grofers.com/cdn-cgi/image/f=auto,fit=scale-down,q=70,metadata=none,w=90/assets/web/blinkit-promises/Best_Prices_Offers.png",
    title: "Best Prices & Offers",
    desc: "Best price destination with offers directly from the manufacturers.",
  },
  {
    img: "https://cdn.grofers.com/cdn-cgi/image/f=auto,fit=scale-down,q=70,metadata=none,w=90/assets/web/blinkit-promises/Wide_Assortment.png",
    title: "Wide Assortment",
    desc: "Choose from 5000+ products across food, personal care, household & more.",
  },
];

const ShopPromises = () => {
  return (
    <div className="blinkit-promises">
      <h4 className="promises-heading">Why shop from us?</h4>

      <div className="promises-list">
        {promises.map((item, index) => (
          <div className="promise-row" key={index}>
            <div className="promise-icon">
              <img src={item.img} alt={item.title} />
            </div>

            <div className="promise-content">
              <div className="promise-title">{item.title}</div>
              <div className="promise-desc">{item.desc}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ShopPromises;
